import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import PretendardText from "../../../component/atoms/text/pretendardText";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import MainInput from "./../../../component/atoms/input/mainInput";
import Checkbox from "./../../../component/atoms/input/checkbox";

import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";

import scrollToTop from "../../../util/scrollToTop";
import { errorHandler } from "../../../util/errorHandler";
import { toastMsg } from "../../../util/toastMsg";
import LevelApi from "../../../api/level.api";
import { route } from "../../../router/route";

const OperationLevel = () => {
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.operation_level)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [levelList, setLevelList] = useState([]);
  const [levelCheckBoxList, setLevelCheckBoxList] = useState([
    {
      id: 1,
      isViewCount: false,
      isWriteCount: false,
      isCommentCount: false,
      isMinViewCount: false,
    },
    {
      id: 2,
      isViewCount: false,
      isWriteCount: false,
      isCommentCount: false,
      isMinViewCount: false,
    },
    {
      id: 3,
      isViewCount: false,
      isWriteCount: false,
      isCommentCount: false,
      isMinViewCount: false,
    },
    {
      id: 4,
      isViewCount: false,
      isWriteCount: false,
      isCommentCount: false,
      isMinViewCount: false,
    },
  ]);

  useEffect(() => {
    getLevelSettingList();
  }, []);

  const getLevelSettingList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "id",
        orderBy: "ASC",
      };

      const response = (await LevelApi.getList(data)).data.data.content;

      let levelCheckBoxTemp = levelCheckBoxList.map((item, index) => {
        return {
          id: item.id,
          isViewCount: response[index].viewCount === 0 ? true : false,
          isWriteCount: response[index].writeCount === 0 ? true : false,
          isCommentCount: response[index].commentCount === 0 ? true : false,
          isMinViewCount: response[index].minViewCount === 0 ? true : false,
        };
      });

      setLevelList(response);
      setLevelCheckBoxList(levelCheckBoxTemp);
    } catch (error) {
      errorHandler(error);
    }
  };

  const editLevelSettingFunc = async () => {
    try {
      for (let i = 0; i < levelList.length; i++) {
        const data = {
          viewCount: Number(levelList[i].viewCount),
          writeCount: Number(levelList[i].writeCount),
          commentCount: Number(levelList[i].commentCount),
          minViewCount: Number(levelList[i].minViewCount),
          limitCount: Number(levelList[i].limitCount),
        };
        await LevelApi.edit(levelList[i].id, data);
      }

      toast(toastMsg.create);
      scrollToTop();

      getLevelSettingList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle
            style={{
              marginBottom: 40,
            }}
          >
            레벨 설정 관리
          </TableTitle>
          <LevelSubTitle>레벨별 조건 설정</LevelSubTitle>
          <LevelItemContainer>
            {/* ************************** */}
            {/* ********** Lv.1 ********** */}
            {/* ************************** */}
            {levelList.length > 0
              ? levelList.map((item, index) => {
                  return (
                    <LevelItemWrapper key={index}>
                      <LevelItemTitle>Lv.{index + 1}</LevelItemTitle>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <MainInput
                          type={"text"}
                          disabled={true}
                          placeholder={""}
                          style={{ width: "338px" }}
                          value={
                            index === 0
                              ? "라이팅뉴비"
                              : index === 1
                              ? "라이팅루키"
                              : index === 2
                              ? "라이팅중수"
                              : index === 3
                              ? "라이팅고수"
                              : index === 4
                              ? "라이팅마스터"
                              : ""
                          }
                          onChange={() => {}}
                        />
                        {index === 0 ? (
                          <PretendardText
                            style={{
                              fontWeight: 500,
                              fontSize: "13px",
                              lineHeight: "18.75px",
                              color: "rgba(181, 181, 181, 0.5)",
                              marginTop: "12px",
                            }}
                          >
                            신규 회원가입자 해당
                          </PretendardText>
                        ) : null}

                        {index !== 4 ? (
                          <>
                            {/* 게시물 조회 */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                margin: "32px 0px 24px 0px",
                              }}
                            >
                              <LevelItemContentText>
                                게시물
                              </LevelItemContentText>
                              <MainInput
                                type={"text"}
                                disabled={levelCheckBoxList[index].isViewCount} // 사용 안 함 체크박스 클릭 시 disabled={true}
                                placeholder={"0"}
                                style={{
                                  width: "93px",
                                  textAlign: "right",
                                }}
                                value={item.viewCount}
                                onChange={(e) => {
                                  let temp = [...levelList];
                                  temp[index].viewCount = e.target.value;

                                  setLevelList(temp);
                                }}
                              />
                              <LevelItemContentText>
                                개 조회
                              </LevelItemContentText>
                              <CheckboxWrapper onClick={() => {}}>
                                <Checkbox
                                  checked={levelCheckBoxList[index].isViewCount}
                                  onChange={() => {
                                    let temp = [...levelCheckBoxList];
                                    temp[index].isViewCount =
                                      !levelCheckBoxList[index].isViewCount;

                                    setLevelCheckBoxList(temp);

                                    let levelListTemp = [...levelList];
                                    levelListTemp[index].viewCount = 0;

                                    setLevelList(levelListTemp);
                                  }}
                                />
                                <CheckboxText>사용 안함</CheckboxText>
                              </CheckboxWrapper>
                            </div>

                            {/* 게시물 작성 */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                marginBottom: 24,
                              }}
                            >
                              <LevelItemContentText>
                                게시물
                              </LevelItemContentText>
                              <MainInput
                                type={"text"}
                                disabled={levelCheckBoxList[index].isWriteCount}
                                placeholder={"0"}
                                style={{
                                  width: "93px",
                                  textAlign: "right",
                                }}
                                value={item.writeCount}
                                onChange={(e) => {
                                  let temp = [...levelList];
                                  temp[index].writeCount = e.target.value;

                                  setLevelList(temp);
                                }}
                              />
                              <LevelItemContentText>
                                개 작성
                              </LevelItemContentText>
                              <CheckboxWrapper onClick={() => {}}>
                                <Checkbox
                                  checked={
                                    levelCheckBoxList[index].isWriteCount
                                  }
                                  onChange={() => {
                                    let temp = [...levelCheckBoxList];
                                    temp[index].isWriteCount =
                                      !levelCheckBoxList[index].isWriteCount;

                                    setLevelCheckBoxList(temp);

                                    let levelListTemp = [...levelList];
                                    levelListTemp[index].writeCount = 0;

                                    setLevelList(levelListTemp);
                                  }}
                                />
                                <CheckboxText>사용 안함</CheckboxText>
                              </CheckboxWrapper>
                            </div>

                            {/* 댓글 */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                marginBottom: 24,
                              }}
                            >
                              <LevelItemContentText>댓글</LevelItemContentText>
                              <MainInput
                                type={"text"}
                                disabled={
                                  levelCheckBoxList[index].isCommentCount
                                }
                                placeholder={"0"}
                                style={{
                                  width: "93px",
                                  textAlign: "right",
                                }}
                                value={item.commentCount}
                                onChange={(e) => {
                                  let temp = [...levelList];
                                  temp[index].commentCount = e.target.value;

                                  setLevelList(temp);
                                }}
                              />
                              <LevelItemContentText>
                                개 작성
                              </LevelItemContentText>
                              <CheckboxWrapper onClick={() => {}}>
                                <Checkbox
                                  checked={
                                    levelCheckBoxList[index].isCommentCount
                                  }
                                  onChange={() => {
                                    let temp = [...levelCheckBoxList];
                                    temp[index].isCommentCount =
                                      !levelCheckBoxList[index].isCommentCount;

                                    setLevelCheckBoxList(temp);

                                    let levelListTemp = [...levelList];
                                    levelListTemp[index].commentCount = 0;

                                    setLevelList(levelListTemp);
                                  }}
                                />
                                <CheckboxText>사용 안함</CheckboxText>
                              </CheckboxWrapper>
                            </div>

                            {/* 내가 쓴 글 중 조회수 */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                marginBottom: 24,
                              }}
                            >
                              <LevelItemContentText>
                                내가 쓴 글 중 조회수
                              </LevelItemContentText>
                              <MainInput
                                type={"text"}
                                disabled={
                                  levelCheckBoxList[index].isMinViewCount
                                }
                                placeholder={"0"}
                                style={{
                                  width: "93px",
                                  textAlign: "right",
                                }}
                                value={item.minViewCount}
                                onChange={(e) => {
                                  let temp = [...levelList];
                                  temp[index].minViewCount = e.target.value;

                                  setLevelList(temp);
                                }}
                              />
                              <LevelItemContentText>
                                이상인 글
                              </LevelItemContentText>
                              <MainInput
                                type={"text"}
                                disabled={
                                  levelCheckBoxList[index].isMinViewCount
                                }
                                placeholder={"0"}
                                style={{
                                  width: "93px",
                                  textAlign: "right",
                                }}
                                value={item.limitCount}
                                onChange={(e) => {
                                  let temp = [...levelList];
                                  temp[index].limitCount = e.target.value;

                                  setLevelList(temp);
                                }}
                              />
                              <LevelItemContentText>개</LevelItemContentText>
                              <CheckboxWrapper onClick={() => {}}>
                                <Checkbox
                                  checked={
                                    levelCheckBoxList[index].isMinViewCount
                                  }
                                  onChange={() => {
                                    let temp = [...levelCheckBoxList];
                                    temp[index].isMinViewCount =
                                      !levelCheckBoxList[index].isMinViewCount;

                                    setLevelCheckBoxList(temp);

                                    let levelListTemp = [...levelList];
                                    levelListTemp[index].minViewCount = 0;
                                    levelListTemp[index].limitCount = 0;

                                    setLevelList(levelListTemp);
                                  }}
                                />
                                <CheckboxText>사용 안함</CheckboxText>
                              </CheckboxWrapper>
                            </div>

                            {/* 내가 쓴 글 중 조회수 */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                marginBottom: 24,
                              }}
                            >
                              <LevelItemContentText>
                                위 조건 충족 시 Lv.{index + 2}로 레벨업
                              </LevelItemContentText>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </LevelItemWrapper>
                  );
                })
              : null}
          </LevelItemContainer>
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            {isWriteAuthority && (
              <BasicBtn
                onClick={() => {
                  editLevelSettingFunc();
                }}
              >
                저장하기
              </BasicBtn>
            )}
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default OperationLevel;

const LevelSubTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 18px;
  line-height: 32.5px;
  letter-spacing: -0.3%;
  color: #f3f3f3;
`;

const LevelItemContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  gap: -0.5px;
`;

const LevelItemWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  border: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
  padding: 24px 0px;
`;

const LevelItemTitle = styled(PretendardText).attrs((props) => {})`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
  margin-top: 12px;
  margin-left: 20px;
`;

const LevelItemContentText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 15px;
  line-height: 22.75px;
  color: #aaa;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  margin-left: 28px;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
`;
